import { render } from "./HComment.vue?vue&type=template&id=0007064c&scoped=true"
import script from "./HComment.vue?vue&type=script&lang=js"
export * from "./HComment.vue?vue&type=script&lang=js"

import "./HComment.vue?vue&type=style&index=0&id=0007064c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0007064c"]])

export default __exports__